/* ShieldCam: no cart drawer. The buy button adds the chosen bundle to the cart in the background (/cart/add.js),
   then goes straight to checkout. To the shopper it is one click to checkout; Shopify/Meta still get the
   add-to-cart event, and the item stays in the cart if they come back from checkout.
   If the Ajax add fails, fall back to the cart permalink (/cart/<variant>:1). Header cart icon = plain link to /cart. */
(function () {
  "use strict";
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var busy = false;
  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (!f.getAttribute || f.getAttribute("id") !== "buyForm") return;
    e.preventDefault();
    if (busy) return;
    var sel = document.querySelector(".bopt.is-sel");
    var id = (sel && sel.dataset.vid) || (f.querySelector("#vId") || {}).value;
    if (!id) { f.submit(); return; }
    busy = true;
    var btn = document.getElementById("btnBuy");
    if (btn) { btn.disabled = true; btn.setAttribute("aria-busy", "true"); btn.textContent = "מעבירים לתשלום…"; }
    fetch(ROOT + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error("add " + r.status); return r.json(); })
      .then(function () { window.location.href = ROOT + "checkout"; })
      .catch(function () { window.location.href = ROOT + "cart/" + id + ":1"; });
  });
  /* back/forward cache: re-enable the button if the shopper returns from checkout */
  window.addEventListener("pageshow", function () {
    busy = false;
    var btn = document.getElementById("btnBuy");
    if (btn && btn.disabled) { btn.disabled = false; btn.removeAttribute("aria-busy"); btn.innerHTML = "להזמנה במחיר המבצע &larr;"; }
  });
})();
